import { InsuranceMetaGrouping } from '@uplift/types';


export { InsuranceMetaGrouping };

export const enum InsuranceCompanyPayerType {
  delegated = 'delegated',
  notDelegated = 'not_delegated',
  medicaid = 'medicaid',
  medicare = 'medicare',
}


export type InsuranceCompany = {
  id: string;
  name: string;
  logoUrl: string;
  url: string;
  createdAt: string;
  updatedAt: string;
  order: number;
  shortName: string;
  key: string;
  payorId: string;

  available: boolean;
  metaGrouping: InsuranceMetaGrouping;
  groupName?: string;
  delegated: boolean;
  payerType: InsuranceCompanyPayerType;
};

export type InsuranceCompanyDetails = {
  insuranceCompanyId: string;
  delegated: boolean;
  unsupportedInsuranceCodes: string[];
  payerEmails: string[];
  insuranceGroup: string | null;
  createdAt: string;
  updatedAt: string;
};

export enum PaymentType {
  cash = 'cash',
  insurance = 'insurance',
}
